var initialState = {
  loyaltyDetails: [],
  loyaltyDetailsStored: false,
  shopId: "",
};

const loyaltyFullDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_LOYALTY_LIST":
      console.log("reducer data", action);
      return {
        ...state,
        loyaltyDetails: action.payload,
        loyaltyDetailsStored: true,
        shopId: action.shopId,
      };
    default:
      return state;
  }
};

export default loyaltyFullDetailsReducer;
